import Decimal from 'decimal.js';

export const dec2fixed = decimal => decimal.toFixed(2).toString();

const transformVatRate = vatRate => {
  const set = new Set(['zw', 'np', 'vz']);
  if (set.has(vatRate)) {
    return '0';
  }

  return vatRate;
};

export const recalculate = (name, value, quantity, grossPrice, netPrice, netValue, vatRate, vatAmount, grossValue) => {
  if (name === 'quantity') {
    return quantityStrategy(value, grossPrice, netPrice, vatRate);
  } else if (name === 'gross_price') {
    return grossPriceStrategy(value, quantity, vatRate);
  } else if (name === 'net_price') {
    return netPriceStrategy(value, quantity, vatRate);
  } else if (name === 'vat_rate') {
    return vatRateStrategy(value, quantity, grossPrice);
  }
};

const quantityStrategy = (value, grossPrice, netPrice, vatRate) => {
  const newQuantity = value;
  const newGrossPrice = grossPrice;
  const newNetPrice = netPrice;
  const newVatRate = vatRate;
  const newGrossValue = dec2fixed(new Decimal(newGrossPrice * newQuantity));
  const newNetValue = dec2fixed(new Decimal(newNetPrice * newQuantity));
  const newVatAmount = dec2fixed(new Decimal(newGrossValue - newNetValue));


  return { newQuantity, newGrossPrice, newNetPrice, newNetValue, newVatRate, newVatAmount, newGrossValue };
};

const grossPriceStrategy = (value, quantity, vatRate) => {
  const newQuantity = quantity;
  const newGrossPrice = value;
  const newVatRate = vatRate;
  const newNetPrice = dec2fixed(new Decimal(newGrossPrice / ((transformVatRate(newVatRate) / 100) + 1)));
  const newGrossValue = dec2fixed(new Decimal(newGrossPrice * newQuantity));
  const newNetValue = dec2fixed(new Decimal(newNetPrice * newQuantity));
  const newVatAmount = dec2fixed(new Decimal(newGrossValue - newNetValue));

  return { newQuantity, newGrossPrice, newNetPrice, newNetValue, newVatRate, newVatAmount, newGrossValue };
};

const netPriceStrategy = (value, quantity, vatRate) => {
  const newQuantity = quantity;
  const newNetPrice = value;
  const newVatRate = vatRate;
  let newGrossPrice = '0.00';
  let newGrossValue = '0.00';
  let newVatAmount = '0.00';
  let newNetValue = '0.00';
  if (!isNaN(value)) {
    newGrossPrice = dec2fixed(new Decimal(newNetPrice).mul((transformVatRate(newVatRate) / 100) + 1));
    newGrossValue = dec2fixed(new Decimal(newGrossPrice * newQuantity));
    newNetValue = dec2fixed(new Decimal(newNetPrice * newQuantity));
    newVatAmount = dec2fixed(new Decimal(newGrossValue - newNetValue));
  }

  return { newQuantity, newGrossPrice, newNetPrice, newNetValue, newVatRate, newVatAmount, newGrossValue };
};

const vatRateStrategy = (value, quantity, grossPrice) => {
  const newVatRate = value;
  const newQuantity = quantity;
  const newGrossPrice = grossPrice;
  const newNetPrice = dec2fixed(new Decimal(newGrossPrice / ((transformVatRate(newVatRate) / 100) + 1)));
  const newGrossValue = dec2fixed(new Decimal(newGrossPrice * newQuantity));
  const newNetValue = dec2fixed(new Decimal(newNetPrice * newQuantity));
  const newVatAmount = dec2fixed(new Decimal(newGrossValue - newNetValue));

  return { newQuantity, newGrossPrice, newNetPrice, newNetValue, newVatRate, newVatAmount, newGrossValue };
};
